import { AnalyticsManager } from "./analyticsManager";
import { mixpanelService } from "./MixpanelTrackingService";

// Instantiating AnalyticsManager with the Mixpanel service.
const analyticsManagerInstance = new AnalyticsManager(mixpanelService);
// Exporting the instantiated AnalyticsManager for global use.
export default analyticsManagerInstance;
